import { Link } from "react-router-dom";
import styled from "styled-components";

export const Wrapper = styled("div")`
  padding: 24px 32px;
  @media (max-width: 1400px) {
    padding: 20px 16px;
  }
  @media (max-width: 768px) {
    padding: 16px 8px;
  }
`;
export const TopHeading = styled("h1")`
  margin: 0 0 0.75em;
  font-weight: 700;
  font-size: 1.5em;
  line-height: 1.2;
  color: #1a1a1a;
  @media (max-width: 768px) {
    font-size: 1.25em;
  }
`;
export const AddButton = styled(Link)`
  height: 36px;
  padding: 0 20px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
  font-weight: 600;
  background: #4a6fa5;
  border-radius: 6px;
  color: #ffffff;
  white-space: nowrap;
  transition: background 0.2s;
  &:hover {
    background: #3d5d8a;
    color: #ffffff;
  }
`;

export const DownloadButton = styled.span`
  height: 36px;
  padding: 0 20px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
  font-weight: 600;
  background: #ffffff;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  color: #333333;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s;
  &:hover {
    color: #4a6fa5;
    border-color: #4a6fa5;
  }
`;
export const SaveBtn = styled("button")`
  height: 36px;
  padding: 0 20px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
  font-weight: 600;
  background: #4a6fa5;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  color: #ffffff;
  white-space: nowrap;
  transition: background 0.2s;
  &:hover {
    background: #3d5d8a;
    color: #ffffff;
  }
  &:disabled {
    background: #a0b4cc;
    cursor: not-allowed;
  }
`;

export const Filter = styled("div")`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5em;
  .ant-input {
    margin-right: 1em;
    max-width: 600px;
    height: 36px;
    font-size: 13px;
    border: 1px solid #d9d9d9;
    border-radius: 6px;
    &::placeholder {
      color: #999999;
    }
  }
`;
export const SoldDate = styled("div")`
  font-weight: 500;
  font-size: 1.5em;
  margin: 0.5em 0 2em;

  .ant-input-number-affix-wrapper {
    .ant-input-number-handler-wrap {
      display: none;
    }
    input {
      height: 40px;
      appearance: none;
      -moz-appearance: textfield;
      padding: 0 !important;
    }
  }
  .ant-input-number-affix-wrapper,
  .ant-input {
    max-width: 600px;
    width: 100%;
    height: 43px;
    background: #ffffff;
    border: 1px solid #434343;
    border-radius: 5px;
    font-size: 1.2em;
    &:hover {
      background: #ffffff;
      border: 1px solid #434343;
    }
  }
  .ant-form-item-label {
    label {
      color: #000000;
      font-size: 1.2em;
    }
  }
  @media (max-width: 1400px) {
    & {
      font-size: 1.2em;
    }
  }
`;
